import waitForLoad from "../utils/waitForLoad";
var domain = 'https://assets.adoberesources.net';
/* eslint-disable */
var loadScript = function loadScript(srcUrl) {
  if (window.AdobeDX) return false;
  (function (d, t, _firstScript$parentNo) {
    var script = d.createElement('script');
    var firstScript = d.getElementsByTagName('script')[0];
    script.src = srcUrl;
    (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 || _firstScript$parentNo.insertBefore(script, firstScript);
  })(document);
  return true;
};
/* eslint-enable */

var load = function load(_ref) {
  var setState = _ref.setState,
    _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? domain : _ref$baseUrl,
    providerKey = _ref.providerKey,
    instanceId = _ref.instanceId,
    env = _ref.env,
    geo = _ref.geo,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  var srcUrl = "".concat(baseUrl, "/loader.js?orgId=").concat(providerKey, "&instanceId=").concat(instanceId, "&env=").concat(env, "&&geo=").concat(geo);
  var loaded = loadScript(srcUrl);

  // Continue as long as Adobe hasn’t already been initialised.
  if (loaded) {
    beforeInit();
    waitForLoad(function () {
      return window.AdobeDX;
    },
    // Allow Adobe to complete loading before removing fake widget
    function () {
      return setTimeout(function () {
        setState('complete');
        onReady();
      }, 2000);
    });
  }
};
var open = function open() {
  return window.addEventListener('adobedx.conversations.ready', function () {
    // There is no way to open the chat programmatically
  });
};
export default {
  domain: domain,
  load: load,
  open: open
};